// libs
import $ from "jquery";
import axios from "axios";
import moment from "moment";
import Vue from "Vue";

// local
import AppBase from "../AppBase";
import { Calendar } from "../../models";
import * as utils from "../../utils";


export default class ModalCalendarApp extends AppBase {
  constructor() {
    super();

    ModalCalendarApp.ROW_MAX = 5;
    this.dataList = [];
    this.vmList = [];
  }

  init() {
    super.init();
    this.initListener();
    this.initVue();
    this.initData();
  }

  initListener() {
    this.scrollTop = 0;

    $("#js-calendarMoreButton").click((e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      $("#js-modalCalendar").fadeIn(200);
      this.scrollTop = $(window).scrollTop();
      $("html").css({"overflow-y": "hidden"});
      this.updatePosition();
      utils.disableScroll();
    });

    $("#js-mocalCalendarCloseButton").click(() => {
      $(window).scrollTop(this.scrollTop);
      $("#js-modalCalendar").fadeOut(100);
      $("html").css({"overflow-y": "auto"});
      $("#js-modalCalendar").scrollTop(0);
      utils.enableScroll();
    });

    $("#modalCalendarMenuToggle").click(() => {
      this.updateMenuState();
    });
  }

  initVue() {
    this.titleData = {
      year: "",
      month: ""
    };

    this.menuData = {
      items: []
    };

    new Vue({
      el: "#js-modalCalenddarTitle",
      data: this.titleData
    });

    new Vue({
      el: "#js-modalCalendarMenu",
      data: this.menuData,
      methods: {
        dateClick: (date) => {
          this.calender = this.calender.selectDate(moment(date));
          this.render();

          const $toggle = $("#modalCalendarMenuToggle");
          const checked = $toggle.prop("checked");
          $toggle.prop("checked", !checked);
          this.updateMenuState();
          this.updatePosition();
        }
      }
    });

    for (let i = 0; i < ModalCalendarApp.ROW_MAX; i++) {
      this.dataList.push({
        items: []
      });

      const vm = new Vue({
        el: `#js-modalCalenddarRow${i+1}`,
        data: this.dataList[i],
        methods: {}
      });
      this.vmList.push(vm);
    }
  }

  initData() {
    axios.get("/data/calendar.json")
    .then(
      response => {
        this.calender = new Calendar().init(response.data);
        this.onInit();
        this.dispatcher.trigger("init");
      },
      error => {
        console.log(error);
      }
    );
  }

  onInit() {
    this.render();
  }

  updateMenuState() {
    const $menu = $("#js-modalCalendarMenu");

    if ($("#modalCalendarMenuToggle").prop("checked")) {
      $menu.show();
    } else {
      $menu.hide();
    }
  }

  updatePosition() {
    const top = $(window).scrollTop();
    console.log(top);
    setTimeout(() => {
      const $modal = $("#js-modalCalendar");
      const $today = $modal.find(".today");

      if ($today.length > 0) {
        // console.log($today, $today.offset().top, top);
        const y = $today.offset().top - top - 90;
        $modal.scrollTop(y);
      } else {
        $modal.scrollTop(0);
      }
    }, 60);
  }

  render() {
    const date = this.calender.selected;

    Vue.set(this.titleData, "year", date.format("YYYY"));
    Vue.set(this.titleData, "month", date.format("M"));

    const menuItems = [];
    const now = moment();

    for (let i = 0; i < 2; i++) {
      menuItems.push({
        year: now.format("YYYY"),
        month: now.format("M"),
        disabled: now.format("M") === date.format("M"),
        date: now.clone().date(1).format()
      });

      now.add(1, "month");
    }

    Vue.set(this.menuData, "items", menuItems);

    let index = 0;

    for (let i = 0; i < ModalCalendarApp.ROW_MAX; i++) {
      const dayElements = this.calender.dayElements.slice(index, index + 7);
      const data = this.dataList[i];
      Vue.set(data, "items", dayElements.toJS());
      index += 7;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/modules/ModalCalendarApp.js